
import Vue from 'vue'
import BaseButton from './BaseButton.vue'
export default Vue.extend({
   name: 'LinkButton',
   props: {
      href: { required: true, type: String },
      label: { default: 'Go', type: String },
      actionLabel: { default: 'Going', type: String },
      showIcon: { default: false, type: Boolean },
      icon: { default: 'glyphicon-ok', type: String },
      type: { default: 'btn-link', type: String },
      block: { default: '', type: String },
      size: { default: '', type: String },
      enabled: { default: true, type: Boolean },
      processing: { default: false, type: Boolean },
   },
   computed: {
      currentLabel(): string {
         return this.processing ? this.actionLabel : this.label
      },
   },
   components: {
      BaseButton,
   },
})
